export default "__VITE_ASSET__6066765c__"